import { CustomFormQuestion } from 'components/tools/CustomForm/types'

export const dynamicNumberValidators = (number: number, question: CustomFormQuestion): string => {
  let error = ''

  if (question?.validation) {
    if (question?.validation?.min) {
      if (number && number < question?.validation?.min) {
        error = 'Número mínimo não alcançado'
      }
    }

    if (question?.validation?.max) {
      if (number && number > question?.validation?.max) {
        error = 'Número máximo ultrapassado'
      }
    }
  }

  return error
}

type ValidateNumberOnCustomFormParams = {
  number: string
  question: CustomFormQuestion
}

export default function validateNumberOnCustomForm({ number, question }: ValidateNumberOnCustomFormParams) {
  let error = ''
  if (question.is_required && !number) {
    error = 'Este campo é obrigatório'
  }
  if (number) {
    const errorMessage = dynamicNumberValidators(Number(number), question)
    if (errorMessage !== '') {
      error = errorMessage
    }
  }
  return error
}
